import { useState, useEffect } from 'react';
import { Flex, Text, SegmentedPicker, ResponsiveEyeSelection } from '../../../2022-component-library';
import { useTestContext } from '../../../context/testContext';

const ResponsiveKaysOptotypesSetup = ({ setCanProgress }) => {
  const [optotypesToShow, setOptotypesToShow] = useState(1);
  const { updateTestData } = useTestContext();

  useEffect(() => {
    updateTestData({ optotypesToShow });
  }, [optotypesToShow, updateTestData]);

  return (
    <Flex column centered>
      <ResponsiveEyeSelection setCanProgress={setCanProgress} showCrowdingOptions />
      <Text size='subHeading' marginBottom='0.5rem' marginTop='-2.5rem'>
        Number of Optotypes
      </Text>
      <SegmentedPicker options={[1, 2, 3, 4, 5]} marginBottom='1rem' selectedOption={optotypesToShow} setSelectedOption={setOptotypesToShow} />
    </Flex>
  );
};

export default ResponsiveKaysOptotypesSetup;
